import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from '../../BaseComponent';
import { LayoutType } from '../../../constants/LayoutConstants';
import { ProjectManagerActions } from '../../../actions/ProjectManagerActions';
import { ProjectManagerStore } from '../../../stores/ProjectManagerStore';
import { DialogActions } from '../../../actions/DialogActions';
import { ViewSettingsActions } from '../../../actions/ViewSettingsActions';
import { ClickButton } from '../../ClickButton';
import { MessageBoxType } from '../../../constants/Enums';
import { ProjectsSortButton } from './ProjectsSortButton';
import { SidebarHeader } from '../../SidebarHeader';

export interface ProjectManagerHeaderProps extends React.Props<ProjectManagerHeader> {
    layoutType: LayoutType;
    editMode: boolean;
    projectsCount: number;
    selectedProjects: Array<string>;
}

export class ProjectManagerHeader extends BaseComponent<ProjectManagerHeaderProps, {}> {
    public render(): JSX.Element {
        return (
            <SidebarHeader text="">
                <div className="sidebar-header-label">{this.props.editMode ? t('Edit projects') : t('Projects')}</div>
                <div
                    className={'project-edit-label' + ((this.props.projectsCount > 0) ? ' active' : '') + (this.props.editMode ? ' done-button' : '')}
                    onClick={this.toggleEdit}
                >
                    <span>{this.props.editMode ? t('Done') : t('Edit')}</span>
                </div>
                {this.editButton()}
            </SidebarHeader>
        );
    }

    protected toggleEdit = () => {
        if (this.props.editMode) {
            ProjectManagerActions.disableEditMode();
        } else {
            ProjectManagerActions.enableEditMode();
        }
    };

    protected nameEdit = () => {
        const project: any = ProjectManagerStore.getSelectedProject(0);
        if (project != null) {
            DialogActions.setProjectName(project.id, project.name);
        }
    };

    protected deleteProject = () => {
        if (this.props.selectedProjects.length > 0) {
            // TODO: use i18next plural forms
            const label: string = this.props.selectedProjects.length > 1 ?
                t('Do you really want to delete the selected projects?') : t('Do you really want to delete the selected project?');
            ViewSettingsActions.showMessage({
                wrap: true,
                element: (
                    <div className="dialog-page-resizer">
                        <div className="dialog-page-header">{label}</div>
                        <ClickButton className="cancel-button" callback={ViewSettingsActions.closeMessage}>{t('Cancel')}</ClickButton>
                        <ClickButton className="submit-button" callback={ProjectManagerActions.deleteSelectedProjects}>{t('Delete')}</ClickButton>
                    </div>
                ),
                type: MessageBoxType.DEFAULT
            });
        }
    };

    protected editButton = (): JSX.Element => {
        if (this.props.editMode) {
            return (
                <div className={'project-edit-buttons' + ((this.props.selectedProjects.length > 0) ? ' active' : '')}>
                    <ClickButton
                        className={'project-clone-button' +  (this.props.selectedProjects.length === 1 ? '' : ' disabled')}
                        callback={ProjectManagerActions.duplicateSelectedProject}
                    />
                    <ClickButton
                        className={'project-name-button' +  (this.props.selectedProjects.length === 1 ? '' : ' disabled')}
                        callback={this.nameEdit}
                    />
                    <ClickButton
                        className={'project-delete-button' +  (this.props.selectedProjects.length > 0 ? '' : ' disabled')}
                        callback={this.deleteProject}
                    />
                </div>
            );
        }
        return <ProjectsSortButton layoutType={this.props.layoutType}/>;
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/projectmanager/ProjectManagerHeader.tsx